import { render } from "./SterrenActieJohannesDeDoperKikirpa.vue?vue&type=template&id=5889f561&scoped=true"
import script from "./SterrenActieJohannesDeDoperKikirpa.vue?vue&type=script&lang=js"
export * from "./SterrenActieJohannesDeDoperKikirpa.vue?vue&type=script&lang=js"

import "./SterrenActieJohannesDeDoperKikirpa.vue?vue&type=style&index=0&id=5889f561&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5889f561"]])

export default __exports__